import { fork } from 'redux-saga/effects';
import apiSaga from './api';
import iframeSaga from './iframe';
import filtersSaga from './filters'

const AppSaga = (payload = {}) => {
    const { facilityid = 1251 } = payload;
    return function* () {
        yield fork(iframeSaga);
        yield fork(apiSaga, facilityid);
        yield fork(filtersSaga, facilityid);
    }
}

export default AppSaga;


// WEBPACK FOOTER //
// ./src/sagas/index.js